import { useFormikContext } from "formik"
import { ImportUsersFormValues, UpdateKeyListUsers, UserGroup } from "../importUsersTypes"
import {
    FormikImportCsvFile,
    ImportCsvFileField,
} from "../../../../../../shared/components/importCsv/FormikImportCsvFile"

export const ImportFile = () => {
    const { values } = useFormikContext<ImportUsersFormValues>()

    const fieldsConfig: ImportCsvFileField[] = [
        {
            name: "employeeNo",
            label: "Employee number",
            optional: values.updateKey !== UpdateKeyListUsers.EMPLOYEE_NUMBER,
        },
        { name: "initials", label: "Initials", optional: values.updateKey !== UpdateKeyListUsers.INITIALS },
        { name: "email", label: "Email", optional: values.updateKey !== UpdateKeyListUsers.EMAIL },
        { name: "userGroupName", label: "User group", optional: values.userGroupId !== UserGroup.FROM_FILE },
        { name: "givenName", label: "Given name", optional: true },
        { name: "familyName", label: "Family name", optional: true },
        { name: "displayName", label: "Display name", optional: true },
        { name: "phoneNumber", label: "Phone number", optional: true },
        { name: "mobileNumber", label: "Mobile number", optional: true },
        { name: "departmentNumber", label: "Department number", optional: true },
        { name: "department", label: "Department", optional: true },
        { name: "cardId", label: "Card ID", optional: true },
        { name: "language", label: "Language", optional: true },
    ]

    return <FormikImportCsvFile<ImportUsersFormValues> fields={fieldsConfig} />
}
